import { memo } from 'react';
const SvgRefreshCcw = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth={2}
    className="refresh-ccw_svg__feather refresh-ccw_svg__feather-refresh-ccw"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M1 4v6h6M23 20v-6h-6" />
    <path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4-4.64 4.36A9 9 0 0 1 3.51 15" />
  </svg>
);
const Memo = memo(SvgRefreshCcw);
export default Memo;
